import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec187454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resumes-view" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "view-controls" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My Resumes", -1))
const _hoisted_5 = { class: "view-toggles" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "sort-controls" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "created" }, "Created Date", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "modified" }, "Last Modified", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "name" }, "Name", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Create new resume")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"skeleton-image\" data-v-ec187454></div><div class=\"card-info\" data-v-ec187454><div class=\"skeleton-title\" data-v-ec187454></div><div class=\"skeleton-date\" data-v-ec187454></div><div class=\"skeleton-actions\" data-v-ec187454><div class=\"skeleton-action\" data-v-ec187454></div><div class=\"skeleton-action\" data-v-ec187454></div><div class=\"skeleton-action\" data-v-ec187454></div></div></div>", 2)
const _hoisted_19 = [
  _hoisted_17
]
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No resumes yet", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create your first resume to get started", -1))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "preview-image" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "card-info" }
const _hoisted_29 = { class: "last-modified" }
const _hoisted_30 = { class: "card-actions" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-files" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { format } from "date-fns";
import { ResumeTemplates } from "../data/Templates";
import { DocumentApiService } from "../services/DocumentApiService";
import type { ResumeListItem } from "../../../server/src/models/dtos/ResumesList";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import CreateResumeModal from "../components/resume-editor/CreateResumeModal.vue";
import DownloadModal from "../components/DownloadModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumesView',
  setup(__props) {

const router = useRouter();
const viewMode = ref("grid");
const sortBy = ref("modified");
const loading = ref(true);
const resumes = ref<ResumeListItem[]>([]);
const createResumeModal = ref<InstanceType<typeof CreateResumeModal> | null>(null);
const downloadModal = ref<InstanceType<typeof DownloadModal> | null>(null);
const selectedResumeId = ref<string | null>(null);

// Fetch resumes on component mount
onMounted(async () => {
  await fetchResumes();
});

// Function to fetch resumes
async function fetchResumes() {
  loading.value = true;
  try {
    const response = await DocumentApiService.getUserResumes();
    resumes.value = response.data.map((resume) => ({
      ...resume,
      id: resume.id || crypto.randomUUID(),
      name: resume.name || "Untitled Resume",
      lastModified: resume.lastModified ? new Date(resume.lastModified) : new Date(),
      previewUrl: resume.previewUrl || null,
    }));
  } catch (error) {
    console.error("Error fetching resumes:", error);
    toast.error("Failed to load resumes. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  } finally {
    loading.value = false;
  }
}

// Add computed property for getting preview image with fallback
const getPreviewImage = (resume: ResumeListItem) => {
  if (resume.previewUrl) {
    return resume.previewUrl;
  }
  // Since we're using the default template, return the first template's preview image
  return ResumeTemplates[0].previewImage;
};

const sortedResumes = computed(() => {
  return [...resumes.value].sort((a, b) => {
    let dateA: Date, dateB: Date;

    switch (sortBy.value) {
      case "created":
        dateA = new Date(a.id);
        dateB = new Date(b.id);
        return dateB.getTime() - dateA.getTime();
      case "modified":
        dateA = a.lastModified;
        dateB = b.lastModified;
        return dateB.getTime() - dateA.getTime();
      case "name":
        return a.name.localeCompare(b.name);
      default:
        return 0;
    }
  });
});

function formatDate(date: Date) {
  return format(date, "MMM d, yyyy");
}

function createNewResume() {
  createResumeModal.value?.show();
}

function showImportModal() {
  router.push({
    name: "UploadResume",
    query: { redirect: "resumes" },
  });
}

async function openResume(id: string) {
  if (id === "new") {
    await router.push({
      name: "NewResume",
    });
  } else if (id != null) {
    router.push({
      name: "EditResume",
      params: { id },
    });
  }
}

function downloadResume(id: string) {
  selectedResumeId.value = id;
  downloadModal.value?.show();
}

async function deleteResume(id: string) {
  // Implement resume deletion logic
  console.log("Delete resume:", id);
  try {
    const response = await DocumentApiService.deleteResume({ id });
    if (response.status === 200) {
      toast.success("Resume deleted successfully");
      await fetchResumes();
    } else {
      toast.error("Failed to delete resume");
    }
  } catch (error) {
    console.error("Error deleting resume:", error);
    toast.error("Failed to delete resume. Please try again.");
  }
}

async function duplicateResume(id: string) {
  try {
    const response = await DocumentApiService.duplicateResume({ id });
    if (response.status === 200) {
      toast.success("Resume duplicated successfully");
      await fetchResumes();
    } else {
      toast.error("Failed to duplicate resume");
    }
  } catch (error) {
    console.error("Error duplicating resume:", error);
    toast.error("Failed to duplicate resume. Please try again.");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CreateResumeModal, {
      ref_key: "createResumeModal",
      ref: createResumeModal
    }, null, 512),
    _createVNode(DownloadModal, {
      ref_key: "downloadModal",
      ref: downloadModal,
      "resume-id": selectedResumeId.value
    }, null, 8, ["resume-id"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["view-toggle", { active: viewMode.value === 'grid' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (viewMode.value = 'grid'))
          }, _hoisted_7, 2),
          _createElementVNode("button", {
            class: _normalizeClass(["view-toggle", { active: viewMode.value === 'list' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'list'))
          }, _hoisted_9, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
          class: "sort-select"
        }, _hoisted_14, 512), [
          [_vModelSelect, sortBy.value]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['resumes-container', viewMode.value])
    }, [
      _createElementVNode("div", {
        class: "resume-card new-resume",
        onClick: createNewResume
      }, _hoisted_16),
      (loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
            return _createElementVNode("div", {
              key: `skeleton-${i}`,
              class: "resume-card skeleton-card"
            }, _hoisted_19)
          }), 64))
        : (resumes.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_24))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(sortedResumes.value, (resume) => {
              return (_openBlock(), _createElementBlock("div", {
                key: resume.id,
                class: "resume-card",
                onClick: ($event: any) => (openResume(resume.id))
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: getPreviewImage(resume),
                    alt: resume.name,
                    class: _normalizeClass({
                'template-blur':
                  !resume.previewUrl ||
                  resume.previewUrl === '/path/to/preview1.jpg' ||
                  resume.previewUrl === '/path/to/preview2.jpg',
              })
                  }, null, 10, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h3", null, _toDisplayString(resume.name), 1),
                  _createElementVNode("p", _hoisted_29, "Last modified " + _toDisplayString(formatDate(resume.lastModified)), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      class: "btn-action",
                      onClick: _withModifiers(($event: any) => (duplicateResume(resume.id)), ["stop"])
                    }, _hoisted_33, 8, _hoisted_31),
                    _createElementVNode("button", {
                      class: "btn-action",
                      onClick: _withModifiers(($event: any) => (downloadResume(resume.id)), ["stop"])
                    }, _hoisted_36, 8, _hoisted_34),
                    _createElementVNode("button", {
                      class: "btn-action delete",
                      onClick: _withModifiers(($event: any) => (deleteResume(resume.id)), ["stop"])
                    }, _hoisted_39, 8, _hoisted_37)
                  ])
                ])
              ], 8, _hoisted_25))
            }), 128))
    ], 2)
  ]))
}
}

})